var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * DocumentPrivate component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconDocumentPrivate extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.35041 2.71497C5.17382 2.71497 5.00446 2.78512 4.87959 2.90999C4.75472 3.03486 4.68457 3.20422 4.68457 3.38081V18.9551C4.68457 19.1317 4.75472 19.301 4.87959 19.4259C5.00446 19.5508 5.17382 19.6209 5.35041 19.6209H10.1122C10.5264 19.6209 10.8622 19.9567 10.8622 20.3709C10.8622 20.7851 10.5264 21.1209 10.1122 21.1209H5.35041C4.77599 21.1209 4.2251 20.8927 3.81893 20.4866C3.41276 20.0804 3.18457 19.5295 3.18457 18.9551V3.38081C3.18457 2.80639 3.41276 2.2555 3.81893 1.84933C4.22511 1.44315 4.776 1.21497 5.35041 1.21497H12.4296C12.6285 1.21497 12.8193 1.29398 12.96 1.43464L20.0392 8.51385C20.1798 8.6545 20.2588 8.84527 20.2588 9.04418V10.9359C20.2588 11.3501 19.9231 11.6859 19.5088 11.6859C19.0946 11.6859 18.7588 11.3501 18.7588 10.9359V9.35484L12.119 2.71497H5.35041Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.7559 16.7314V15.9635C15.7559 15.6648 15.8608 15.3769 16.0502 15.1491C16.1351 15.0471 16.236 14.9554 16.3425 14.8731C16.5362 14.7236 16.7568 14.6157 17 14.6157C17.3004 14.6157 17.6134 14.7803 17.847 14.9848L17.9804 15.1157C18.188 15.3485 18.3035 15.65 18.3035 15.9635V16.7314H15.7559ZM14.2559 16.7552V15.9635C14.2559 15.2279 14.5481 14.5223 15.0683 14.0021C15.5885 13.4819 16.294 13.1897 17.0297 13.1897C17.7654 13.1897 18.4709 13.4819 18.9911 14.0021C19.5113 14.5223 19.8035 15.2278 19.8035 15.9635V16.7551C20.3805 16.8686 20.8156 17.3772 20.8156 17.9874V21.5291C20.8156 22.2228 20.2533 22.7851 19.5597 22.7851H14.5001C13.8064 22.7851 13.2441 22.2228 13.2441 21.5291V17.9874C13.2441 17.3773 13.6791 16.8688 14.2559 16.7552ZM14.7441 21.2851V18.2314H19.3156V21.2851H14.7441Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconDocumentPrivate.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconDocumentPrivate.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconDocumentPrivate.prototype, "size", void 0);
if (customElements.get('cat-icon-document-private') === undefined) {
    customElements.define('cat-icon-document-private', BlocksIconDocumentPrivate);
}
